<template>
  <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
      title="查看图片"
      width="600px"
      top="5vh">
    <div
        v-for="item in pictureList"
        :key="item.pkid">
      <span style="position: relative">
        <img width="200px" height="200px" :src="getPhotoPath(item.photoPath)" @click.self="showBigImage($event)">
        <div class="watermark">
          <div v-if="isGuangRi" class="watermark-right">
            <div class="watermark-row">
              <span class="watermark-item">{{waterPrint.companyName}}</span>
              <span class="watermark-item">{{waterPrint.pcNo}}</span>
            </div>
            <div class="watermark-row">
              <span class="watermark-item">{{waterPrint.createdTime}}</span>
            </div>
          </div>
          <div v-else class="watermark-single">
            <span>{{waterPrint.pcNo}}</span>
          </div>
        </div>
      </span>
    </div>

    <big-img
        :visible="photoVisible"
        :url="bigImgUrl"
        :pc-no="waterPrint.pcNo"
        :water-print="waterPrint"
        :show-water-print="isGuangRi"
        @closeClick="photoVisible = false"/>
  </el-dialog>
</template>

<script>

  import BigImg from "@/components/BigImg";
  export default {
    name:"PictureList",
    components: {BigImg},
    data() {
      return {
        photoVisible: false,
        bigImgUrl: "",
        pcNo: "",
        waterPrint: {
          pcNo: "",
          createdTime: "",
          companyName: "",
        },
        dialogVisible: false,
        pictureList:[],
      };
    },
    computed: {
      // 仅当公司名称包含"广日"时展示三个字段
      isGuangRi() {
        return !!(this.waterPrint.companyName && String(this.waterPrint.companyName).includes("广日"));
      },
    },
    methods: {
      open(photos,waterPrint) {
        this.dialogVisible = true;
        this.pictureList = photos;
        this.waterPrint.pcNo = waterPrint.pcNo;
        this.waterPrint.createdTime = waterPrint.createdTime;
        this.waterPrint.companyName = waterPrint.companyName;
      },
      getPhotoPath(path) {
        return  window.config.basicServerHttpUrl + "file/download?uuid=" + path+"&name=" + "PIC.jpeg";
      },
      showBigImage(e) {
        //点击图片函数，点击后，把photoVisible设置成true
        if (e != "") {
          this.photoVisible = true;
          this.bigImgUrl = e.currentTarget.src;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
.watermark {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 4px 0px;
  color: white;
  font-size: 10px;
  line-height: 16px;
  background: rgba(0, 0, 0, 0.4);
}
.watermark-row {
  display: flex;
  justify-content: space-between;
}
.watermark-single {
  display: flex;
  justify-content: center;
}
.watermark-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.watermark-right .watermark-row {
  justify-content: flex-end;
}
.watermark-row-center {
  justify-content: center;
}
.watermark-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}
.watermark-item:last-child {
  margin-right: 0;
}
</style>
